// extracted by mini-css-extract-plugin
export default {"img":"styles_img__UeXVK","imgContainer":"styles_imgContainer__aaRxq","download":"styles_download__XknOf","icon":"styles_icon__NVpi8"};